module.exports = __webpack_public_path__ + "img/payments_re.351d5604.png";